import { render } from "./holiday-deals-tst-com.vue?vue&type=template&id=1f2ce66a&scoped=true"
import script from "./holiday-deals-tst-com.vue?vue&type=script&lang=js"
export * from "./holiday-deals-tst-com.vue?vue&type=script&lang=js"

import "./holiday-deals-tst-com.vue?vue&type=style&index=0&id=1f2ce66a&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2ce66a"]])

export default __exports__